import propTypes from 'prop-types'
import {Flex, Button, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {PencilIcon} from '../../../icons'
import {
  ExpenseAccountSandwichList,
  CreateExpenseAccountForm,
} from '../components'
import {useRails} from '../../../contexts/rails'

const InformationScreen = ({
  handleClose,
  goToNextStep,
  onCreateExpenseAccount,
  isCreatingExpenseAccount,
}) => {
  const {t} = useTranslation('connectExpenseAccount')
  const {accountingProvider} = useRails()

  const handleFormSubmit = async (values) => {
    await onCreateExpenseAccount({
      name: values.name,
      description: values.description,
    })
  }

  return (
    <Flex justify="center">
      <Flex flexDirection="column" width="400px" gap={6} pt={10}>
        {/* Title section */}
        <Flex flexDirection="column" gap={6}>
          <Text
            color="black"
            fontWeight="regular"
            fontSize="2xl"
            lineHeight="90%"
          >
            {t('modal.information.title')}
          </Text>
          <Text color="black" fontSize="14px" lineHeight="125%">
            {t('modal.information.description', {
              accounting_provider: accountingProvider.name,
            })}
          </Text>
        </Flex>

        {/* Expense account display section */}
        <Flex
          background="mld.neutral.50"
          justify="space-between"
          alignItems="center"
        >
          <Flex flexDirection="column" gap={2} p={4}>
            <Text
              color="black"
              fontSize="14px"
              lineHeight="125%"
              textTransform="uppercase"
            >
              {t('modal.information.expenseAccount.title')}
            </Text>
            <Text color="black" fontSize="18px" lineHeight="125%">
              {t('modal.information.expenseAccount.defaultAccountName')}
            </Text>
          </Flex>
          <Button
            align="center"
            variant="secondary"
            m={2}
            leftIcon={<PencilIcon boxSize={5} />}
            onClick={goToNextStep}
          >
            {t('buttons.change')}
          </Button>
        </Flex>

        <ExpenseAccountSandwichList />

        {/* Form */}
        <CreateExpenseAccountForm onSubmit={handleFormSubmit} hideFields />
        <Flex gap={3} pt={2} mb={8}>
          <Button
            type="submit"
            form="create-expense-account-form"
            variant="primary"
            isLoading={isCreatingExpenseAccount}
          >
            {t('buttons.create')}
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            {t('buttons.cancel')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

InformationScreen.propTypes = {
  handleClose: propTypes.func.isRequired,
  goToNextStep: propTypes.func.isRequired,
  onCreateExpenseAccount: propTypes.func.isRequired,
  isCreatingExpenseAccount: propTypes.bool.isRequired,
}

export default InformationScreen
